export default {
  methods: {
    logOut() {
      this.axios({
        method: "post",
        url: "logout",
        baseURL: "/",
      })
        .then(() => {
          this.$emit("change");
          window.location.replace("/");
        })
        .catch(function(error) {
          console.error(error);
        });
    },
  },
};
